import { WEBPHONE_DISABLED_PATHS } from "@/components/webphone/constants"
import { usePathname } from "next/navigation"
import { useMemo } from "react"

export function useWebphoneIsDisabled() {
  const pathname = usePathname()

  const isDisabled = useMemo(() => WEBPHONE_DISABLED_PATHS.find((i) => pathname.includes(i)) !== undefined, [pathname])

  return isDisabled
}
